import { render, staticRenderFns } from "./LsProductDetail.vue?vue&type=template&id=e09c4f2e&scoped=true&"
import script from "./LsProductDetail.vue?vue&type=script&lang=js&"
export * from "./LsProductDetail.vue?vue&type=script&lang=js&"
import style0 from "./LsProductDetail.vue?vue&type=style&index=0&id=e09c4f2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e09c4f2e",
  null
  
)

export default component.exports